<app-thread-view [orgId]="orgId" [refId]="threadId" [mode]="mode">
</app-thread-view>
